import { menuTypeDict } from '@/dictionary/menu'
import { companyTypeDict } from '@/dictionary/company'
import {
  platformFunctionModuleDict,
  workbenchServiceDict
} from '@/dictionary/system'

/**
 * 框架协议
 */
export default {
  path: 'frame-agreement',
  type: menuTypeDict.DIRECTORY.value,
  meta: {
    title: '框架协议',
    icon: 'icon-side_supplier_lib_agreement',
    layout: 'DefaultLayout'
  },
  applicableCompanyTypes: [
    { companyType: companyTypeDict.ENTERPRISE.value },
    { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
  ],
  platformAlias: [],
  applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
  roles: [
    platformFunctionModuleDict.FRAMEWORK_AGREEMENT.right,
    platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
  ],
  superviseInstitutions: [],

  children: [
    // 协议列表
    {
      path: 'list',
      name: 'DemandFrameAgreementList',
      component: '/supplier-manage-views/frame-agreement/list',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '协议列表',
        cache: true,
        hidden: true
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
      roles: [
        platformFunctionModuleDict.FRAMEWORK_AGREEMENT.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    },

    // 新增协议
    {
      path: 'agreementId/:agreementId?/create',
      name: 'DemandFrameAgreementCreate',
      component: '/supplier-manage-views/frame-agreement/create',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '新增协议',
        hidden: true,
        needFormKey: true
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
      roles: [
        platformFunctionModuleDict.FRAMEWORK_AGREEMENT.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    },

    // 协议详情
    {
      path: 'agreementId/:agreementId/detail',
      name: 'DemandFrameAgreementDetail',
      component: '/supplier-manage-views/frame-agreement/detail',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '协议详情',
        hidden: true
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
      roles: [
        platformFunctionModuleDict.FRAMEWORK_AGREEMENT.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    }
  ]
}
